import SaveList from '@/Component/Brand/SaveList'
import React from 'react'

const SaveListPage = () => {
  return (
    <div>
       <SaveList />
    </div>
  )
}

export default SaveListPage
